export default {
  kebabCase: string =>
    string
      .replace(/([a-z])([A-Z])/g, '$1-$2')
      .replace(/\s+/g, '-')
      .toLowerCase(),
  pascalCase: string =>
    string
      .match(/[a-z]+/gi)
      .map(word => {
        return word.charAt(0).toUpperCase() + word.substr(1).toLowerCase();
      })
      .join(''),
};
